export enum UserRole {
    USER = 0,
    SUPER_ADMIN = 1,
    ADMIN = 2,
    TEACHER = 3
} 